export type FormattedLanguage = Readonly<{
  code: string;
  flag: string;
  label: string;
  display: string;
}>;

/**
 * Format language data for display in the selector
 * @param code - Language code (e.g., "en-US")
 * @param flag - Flag emoji (e.g., "🇺🇸")
 * @param label - Translated language name (e.g., "English (United States)")
 * @returns Formatted language object with display strings
 */
export function formatLanguage(code: string, flag: string, label: string): FormattedLanguage {
  return {
    code,
    flag,
    label,
    // Display: "🇺🇸 English (United States)"
    display: `${flag} ${label}`,
  };
}

/**
 * Human-readable label for a stored code outside the supported options list.
 * Legacy events hold ~200 distinct locale codes (e.g. en-CA, nl-NL, es-419)
 * written by the V1 picker and by pre-normalization browser-locale detection.
 * Localized via Intl.DisplayNames; returns the raw code when the tag is
 * unparsable or the API is unavailable.
 */
export function formatUnknownLanguage(code: string, displayLocale: string | undefined): string {
  try {
    // eslint-disable-next-line compat/compat -- missing on old Safari; the catch falls back to the raw code
    return new Intl.DisplayNames([displayLocale || 'en', 'en'], { type: 'language', languageDisplay: 'standard' }).of(code) || code;
  } catch {
    return code;
  }
}
